export default __webpack_public_path__ + "static/media/alert-circle.f2638523.svg";